import {
  AnalysisItem,
  GroupTableType,
  LayerGroupType,
  LocationItem
} from "helpers/models";
import getColor from "report/common/color-rule";

export default (
  groupData: Record<string, Record<string, AnalysisItem[]>>,
  locationItems: LocationItem[],
  legend: LayerGroupType,
  aggregationUnits: string[]
): GroupTableType => {
  const locationMap = Object.fromEntries(
    locationItems.map((item: LocationItem) => [item.id.replaceAll('-', ''), item])
  );

  const groupDetail = Object.entries(groupData).reduce(
    (acc, [layerId, byLabel]) => {
      const detailTable: any[] = [];

      Object.entries(byLabel).forEach(([label, items]) => {
        const row: Record<string, any> = {
          label: label,
          // [e]: sum,
          count: items.length,
          color: getColor(label, legend[layerId])
        };

        aggregationUnits
          .filter((e) => e !== "numberOfLocations")
          .forEach((e) => {
            const sum = items.reduce((acc, i) => {
              if (i.pointId) {
                const locationItem = locationMap[i.pointId.replaceAll('-', '')];
                if (!locationItem) {
                  return 0;
                }
                const agg = locationItem[e as keyof LocationItem];
                if (typeof agg === "number") {
                  return acc + agg;
                }
              }
              return acc;
            }, 0);

            if (sum > 0) {
              row[e] = sum;
            }
          });

        detailTable.push(row);
      });

      // const sortedData = sortData(detailTable, legend[layerId]);
      
      if (detailTable && detailTable.length > 0) {
        acc[layerId] = detailTable;
      }
      return acc;
    },

    {} as GroupTableType
  );

  return groupDetail;
};
